import React from 'react';

import './gauge.scss';

interface Position {
  x: number;
  y: number;
}

interface GaugeProps {
  className?: string;
  draw?: boolean;
  fillPerc: number;
  gaugeColor?: string;
  gaugeHeight?: number;
  gaugeStrokeWidth?: number;
  label?: string;
  labelPos?: Position;
  showBezel?: boolean;
  showTrack?: boolean;
  value?: string | number;
  valuePos?: Position;
}

function Gauge(props: GaugeProps) {
  const {
    className,
    draw = false,
    fillPerc,
    gaugeColor,
    gaugeStrokeWidth,
    gaugeHeight = 78,
    label,
    labelPos,
    showBezel = true,
    showTrack = false,
    value,
    valuePos
  } = props;
  const pathLength = 628.4;
  const fillPathLength = pathLength - pathLength * fillPerc;
  const gaugeStyle = {
    stroke: gaugeColor,
    strokeWidth: gaugeStrokeWidth
  };
  const bezelStyle = {
    strokeWidth: gaugeStrokeWidth
  };

  return (
    <svg
      className={`gauge ${className || ''}`}
      height={gaugeHeight}
      viewBox="0 0 250 250"
    >
      {showTrack && (
        <path
          className="gauge__track"
          d="M 125 125 m -100, 0 a 100,100 0 1,0 200,0 a 100,100 0 1,0 -200,0"
          data-testid="gauge-track"
        />
      )}

      <path
        d="M 125 125 m 0, -100 a 100,100 0 1,1 0,200 a 100,100 0 1,1 0,-200"
        data-testid="gauge-bg"
        strokeDasharray={pathLength}
        strokeDashoffset={1}
        style={{
          stroke: '#C3C3C6',
          strokeWidth: gaugeStrokeWidth
        }}
        styleName={`fill ${draw ? 'draw' : ''}`}
      />

      <path
        className={`gauge__fill ${draw ? 'gauge__fill--draw' : ''}`}
        d="M 125 125 m 0, -100 a 100,100 0 1,1 0,200 a 100,100 0 1,1 0,-200"
        data-testid="gauge-fill"
        strokeDasharray={pathLength}
        strokeDashoffset={fillPathLength}
        style={gaugeStyle}
        styleName={`fill ${draw ? 'draw' : ''}`}
      />

      <text
        className="gauge__value"
        data-testid="gauge-value"
        styleName="value"
        textAnchor="middle"
        x={valuePos?.x || 125}
        y={valuePos?.y || 155}
      >
        {value}
      </text>

      {label && (
        <text
          className="gauge__label"
          data-testid="gauge-label"
          styleName="label"
          textAnchor="middle"
          x={labelPos?.x || 125}
          y={labelPos?.y || 170}
        >
          {label}
        </text>
      )}

      {showBezel && (
        <path
          className="gauge__bezel"
          d="M 125 125 m -100, 0 a 100,100 0 1,0 200,0 a 100,100 0 1,0 -200,0"
          data-testid="gauge-bezel"
          strokeDasharray="7 118"
          strokeDashoffset="32"
          style={bezelStyle}
          styleName="bezel"
        />
      )}
    </svg>
  );
}

export default Gauge;
